import * as React from "react";
interface SVGProps {
  height?: number | string;
  width?: number | string;
  color?: string;
}

const SvgArrowRight = (props: SVGProps) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.72768 1.36255L12.7388 7.00009L7.72768 12.6376L6.8557 11.8625L10.6594 7.58343H1.16669V6.41676H10.6594L6.8557 2.13764L7.72768 1.36255Z"
        fill={props.color || "#FF5900"}
      />
    </svg>
  );
};

export default SvgArrowRight;
